import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { useSecretStore } from '../store';

/* eslint-disable import/prefer-default-export */
export function getVisitorId() {
  return new Promise((resolve) => {
    FingerprintJS.load().then((fp) => {
      const useStore = useSecretStore();
      fp.get().then((result) => {
        useStore.changeYdId(result.visitorId)
        resolve(result.visitorId);
      });
    });
  });
}
